import styled, { css } from 'styled-components';

export default styled.div`
  position: absolute;
  top: 60px;
  left: 0;
  z-index: 100;
  border-radius: 0 10px 10px 0;
  background-color: rgba(0, 0, 0, 0.85);
  box-shadow: 0px 0px 20px #00000029;
  transition: all 290ms ease;
  width: 100%;
  max-width: ${({ expanded }) => (expanded ? '375px' : '40px')};
  height: ${({ expanded }) => (expanded ? 'auto' : '40px')};
  ${({ expanded }) =>
    !expanded &&
    css`
      background-color: transparent;
      overflow: hidden;
    `}
  ${({ full }) =>
    full &&
    css`
      top: 0;
      bottom: 0;
      border-radius: 0;
    `}
  @media (max-width: ${({ theme }) => theme.devices.mobile}) {
    top: inherit;
    bottom: 0;
    border-radius: 0;
    max-width: ${({ expanded }) => (expanded ? '100%' : '60px')};
  }
`;
